import { ShieldCheck, FileSearch, GitMerge, ArrowRight } from 'lucide-react';

const pillars = [
  {
    icon: ShieldCheck,
    number: '01',
    title: 'Pre-Op Authorization',
    subtitle: 'Intelligent Subset Bundles',
    body: 'LINK auto-expands primary procedures into comprehensive authorization bundles—covering primary codes and plausible variations before the surgeon enters the OR.',
    outcome: 'Prevents un-authorized work from reaching the billing office.',
  },
  {
    icon: FileSearch,
    number: '02',
    title: 'Intra-Op Evidence',
    subtitle: 'Proof Mapping Logic',
    body: 'High-fidelity dictation capture is parsed through Proof Mapping—extracting CPT evidence directly from the clinical narrative without inventing facts.',
    outcome: 'Every billed code is linked to documented clinical evidence.',
  },
  {
    icon: GitMerge,
    number: '03',
    title: 'Post-Op Reconciliation',
    subtitle: 'The Hard Gate',
    body: 'A three-way reconciliation engine ensures a code only reaches billing if it is Authorized, Documented, and Surgeon-Confirmed. No exceptions.',
    outcome: 'Authorization = Documentation = Export. Always.',
  },
];

const ValuePillarsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header — centered */}
        <div className="text-center mb-12 md:mb-16 max-w-2xl mx-auto">
          <span className="text-xs font-medium text-primary tracking-wide uppercase">Closed-Loop Architecture</span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight mt-3 mb-6">
            Three Pillars. One Standard.
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Every billable code passes through three independent enforcement layers before it
            reaches your billing system.
          </p>
        </div>

        {/* Grid — left-aligned card contents */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {pillars.map((pillar) => (
            <div
              key={pillar.number}
              className="bg-card border border-border rounded-md p-8 h-full transition-all hover:shadow-lg"
            >
              {/* Number + Icon */}
              <div className="flex items-center justify-between mb-6">
                <span className="text-xs font-mono text-muted-foreground tracking-widest">{pillar.number}</span>
                <div className="w-10 h-10 rounded-md bg-primary/5 border border-primary/15 flex items-center justify-center">
                  <pillar.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
                </div>
              </div>

              <h3 className="text-xl font-semibold text-foreground mb-1">{pillar.title}</h3>
              <p className="text-xs text-primary font-medium mb-4">{pillar.subtitle}</p>
              <p className="text-sm text-muted-foreground leading-relaxed mb-6">{pillar.body}</p>

              <div className="flex items-start gap-2 pt-4 border-t border-border">
                <ArrowRight className="h-3.5 w-3.5 text-primary mt-0.5 flex-shrink-0" />
                <p className="text-xs text-primary font-medium leading-relaxed">{pillar.outcome}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePillarsSection;
